var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShowComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.71,5.29l-2-2L20,3H4l-.71.29-2,2L1,6v9l.29.71,2,2L4,18H6.43l2.71,4.51h1.72L13.57,18H20l.71-.29,2-2L23,15V6ZM21,14.59,19.59,16H13l-.86.49L10,20.06,7.86,16.49,7,16H4.41L3,14.59V6.41L4.41,5H19.59L21,6.41Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShowComments);
export default __webpack_public_path__ + "static/1787897133/media/icon-show-comments.308ff7d252c9781afc61e6779a9987df.svg";
export { ForwardRef as ReactComponent };